/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";

const Success = ({ name, email }) => {
  const [numberOfPrompts, setNumberOfPrompts] = useState(0);

  useEffect(() => {
    // Load prompts for this category from JSON
    const filename = name.toLowerCase().replace(/\s/g, "");
    axios.get(`/app/${filename}prompts.json`).then((response) => {
      // Get number of prompts
      const prompts = response.data.prompts.split("^");
      setNumberOfPrompts(prompts.length);
    });
  }, []);

  return (
    <>
      <h2>Purchase successful</h2>
      <p>
        Thank you for purchasing the <strong>{name}</strong> premium category.
      </p>
      <p>
        You can now access all of the <strong>{numberOfPrompts} prompts</strong>{" "}
        from the web app.
      </p>
      <p>
        A receipt of the purchase will be emailed to the{" "}
        <span style={{ color: "#ff652f" }}>{email}</span> email.
      </p>
    </>
  );
};

const mapStateToProps = (state) => ({
  email: state.email,
});

export default connect(mapStateToProps)(Success);
